// Chapter registry for the manymux book. Source of truth: the NN-*.md files
// beside this one (hand-edited). Mirrors ../docs/manifest.js; the registry
// logic they share lives in ../docs/book.js.
//
// Docs synced to manymux@3f616c1 (0.2.1, 2026-10-12). Written from the
// repo's README, the clap help in src/main.rs and the architecture notes in
// CLAUDE.md, so they cover a few things the README does not: groups
// (`mm group` / `mm groups`) and the exit codes.
//
// New (manymux@6837e09..3f616c1): current-directory shells, host transport reuse,
// detach return commands, macOS foreground inspection, stable group choices,
// Android saved hosts, background sessions, selection, and Shift controls.
//
// Previously (manymux@a067031..6837e09): session search, numbered recent sessions,
// machine picker for new sessions, live group-filter updates, duplicate-host
// reporting, and stable scrollback while output arrives. History search lives
// inside the scrollback; the control popup searches session names and titles.
//
// Previously (manymux@eeaee64..a067031): releases (and nightlies) carry
// `manymux-android.apk`, built from the same commit as the binaries, so the app
// installs without a checkout and an NDK; debug-signed for now, so each release
// looks like a different app to Android. A selection is a background band rather
// than a repaint, so the colour, bold, underline and italics under it survive
// (reversed text has the swap undone, and a foreground the band would swallow
// gives way by contrast). `groups.toml` is read-modify-write: a client held the
// copy it read at startup and wrote the whole map back, so a session moved into a
// group in one window fell out of it the next time another window listed.
//
// Previously (manymux@426bbec..eeaee64): the Android app under `android/` (a cdylib
// shim making its own ssh connection plus a Kotlin app; no mode key, a wall of
// session screens rather than a list of names, scrollback as a drag that yields
// to a program reading the mouse, its own generated key and TOFU host keys since
// a phone has no ~/.ssh, and a `reach` example that runs the whole stack from a
// terminal). Got its own Guide chapter (07), so 07-09 shifted to 08-10. New
// protocol request `Peek`, which answers with each session's screen and its
// size without making a client of the asker, so drawing thumbnails neither
// announces a viewer nor squeezes the session; a node too old to decode it
// answers with an error naming its version. The CLI surface itself is unchanged
// in this range: the rest is app fixes plus two attach fixes (the popup opens on
// the session the run is in; what ssh prints stays off a screen a wait is
// holding).
//
// Chapters are grouped into sections in the sidebar. `section` is the group
// label; order within the array is the reading order (prev/next + the llms.txt
// index, which sorts by the NN file prefix, so keep prefix == reading order).
const chapters = [
  // Guide: install it, then one chapter per thing you do with it.
  { num: 1, section: "Guide", slug: "01-introduction", title: "Introduction" },
  { num: 2, section: "Guide", slug: "02-getting-started", title: "Getting Started" }, // prettier-ignore
  { num: 3, section: "Guide", slug: "03-sessions-and-targets", title: "Sessions and Targets" }, // prettier-ignore
  { num: 4, section: "Guide", slug: "04-control-mode", title: "Control Mode" },
  { num: 5, section: "Guide", slug: "05-machines", title: "Machines" },
  { num: 6, section: "Guide", slug: "06-notifications-and-settings", title: "Notifications and Settings" }, // prettier-ignore
  { num: 7, section: "Guide", slug: "07-android", title: "The Android App" },
  // Reference: the command table, the operational chapter, and the internals.
  { num: 8, section: "Reference", slug: "08-cli-reference", title: "CLI Reference" }, // prettier-ignore
  { num: 9, section: "Reference", slug: "09-keeping-it-running", title: "Keeping It Running" }, // prettier-ignore
  { num: 10, section: "Reference", slug: "10-how-it-works", title: "How It Works" }, // prettier-ignore
];

// Which `mm` the docs currently describe. Surfaced in the docs sidebar and kept
// in step with readme.md ("Docs sync"). Bump both together.
export const docsSync = { commit: "3f616c1", date: "2026-10-12" };

// See ../docs/manifest.js for what DocsView does with this.
export const meta = {
  id: "manymux",
  label: "The manymux Book",
  base: "/manymux/docs",
  binary: "mm",
  sync: docsSync,
  back: { to: "/manymux", label: "manymux" },
};

export default chapters;
